import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import BaseTableInCard, { useChoicelistCellDefinition } from '../../common/BaseTable/BaseTableInCard';
import { useIsLoading } from '../../common/Hooks/useIsLoading';
import visitAction from '../visitAction';
import { ENDPOINTS } from '../../../actions/Api/constants';
import { editVisitAction } from '../../../actions/Navigation/VisitAction/editVisitAction';
import meeting from '../../Communication/meeting';

const CommunicationVisitActionsTable = ({ visitActions }) => {
    const isLoading = useIsLoading([ENDPOINTS.API.PAGE]);
    const dispatch = useDispatch();
    const columns = [
        { ...visitAction.startDate, filter: true, sortable: true },
        visitAction.assignee,
        useChoicelistCellDefinition(visitAction.activityRegarding, { width: 200 }),
        useChoicelistCellDefinition(visitAction.status, { width: 200 })
    ];
    const editRow = visitAction => dispatch(editVisitAction(visitAction));

    return (
        <BaseTableInCard
            cardTitle={`Visit Actions (${visitActions.length})`}
            columns={columns}
            data={visitActions}
            isLoading={isLoading}
            noItemMessage="No Contacts"
            onRowClicked={({ rowData }) => editRow(rowData)}
            rowKey={meeting.id.field}
            tableSizeStyle={{ height: 'calc(100vh /5)', width: '100%' }}
        />
    );
};

const makeMapStateToProps = () => {
    const getState = createSelector(
        [(state, { meetingId }) => state.visitActions.filter(visitAction => visitAction.meetingId === meetingId)],
        visitActions => ({
            visitActions
        })
    );
    return (state, props) => getState(state, props);
};

export default connect(makeMapStateToProps)(CommunicationVisitActionsTable);
